<button
    (click)="export()"
    class="x-btn-primary icon-btn export-button big-scr"
    [disabled]="!hasData || loading"
    [translate]="'trends.button.export'"
></button>
<button (click)="export()" class="x-btn-primary icon-btn export-button small-scr" [disabled]="!hasData || loading">
    <mat-icon class="export-btn-icon">file_download</mat-icon>
</button>
